import { Menu } from "antd";

import SignOut from "../signOut";

const UserMenu = () => (
  <Menu items={[{ key: 0, label: <SignOut /> }]} className="dropdown-menu" />
);

export default UserMenu;
